export default __webpack_public_path__ + "static/media/freebsd.0dc90bc2.svg";